import typeToReducer from 'type-to-reducer'

import helpItemFacade from '../facades/helpItem'

export default typeToReducer({}, helpItemFacade().get())
